import React, { useState } from "react";
import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import { downloadSandboxPalletTest } from "../../api/lab";
import { handleDownload } from "../../services/PDFHandler.ts";
import { useSnack } from "../../services/SnakbarProvider";

// Lab/testing screen: runs the ported pallet-split / customs / pricing / RFID logic
// against a real Export and downloads a plain (untemplated) xlsx with the results, so
// the port from the Tkinter app can be checked by hand. Safe to delete once that logic
// is verified and wired into the real invoice/packing-list/BOL generation.
const SandboxScreen = () => {
  const { openSnack } = useSnack();
  const [exportId, setExportId] = useState("");
  const [splitMode, setSplitMode] = useState("balanced");
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    if (!exportId) {
      openSnack("Escribe un ID de exportación", "warning");
      return;
    }

    setLoading(true);
    try {
      const response = await downloadSandboxPalletTest(exportId, splitMode);
      handleDownload(
        response,
        `sandbox_pallet_test_${exportId}.xlsx`,
        "No se pudo generar el archivo de prueba",
        () => openSnack("No se pudo generar el archivo de prueba", "error")
      );
    } catch (e) {
      openSnack("No se pudo generar el archivo de prueba", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 360 }}>
      <Typography variant="h6">Sandbox de exportaciones</Typography>
      <Typography variant="body2" color="text.secondary">
        Genera un xlsx sin plantilla con el desglose de pallets, aduana, precios
        y RFID calculado para una exportación real, para verificar la migración
        de la lógica de la app de escritorio (Tkinter).
      </Typography>
      <TextField
        label="ID de exportación"
        type="number"
        value={exportId}
        onChange={(e) => setExportId(e.target.value)}
      />
      <TextField
        select
        label="Modo de división de pallets"
        value={splitMode}
        onChange={(e) => setSplitMode(e.target.value)}
      >
        <MenuItem value="balanced">Balanced (divide el tail)</MenuItem>
        <MenuItem value="remainder">Remainder (sobrante en su propio pallet)</MenuItem>
      </TextField>
      <Button variant="contained" onClick={handleGenerate} disabled={loading}>
        {loading ? "Generando..." : "Generar xlsx de prueba"}
      </Button>
    </Box>
  );
};

export default SandboxScreen;
